// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class TradingUnlockMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_TRADING_UNLOCK_MESSAGE, fieldSet);
    }
    SetPassword(password) {
        this.setFieldValue(FieldsFactory.FIELD_PASSWORD, password);
    }
    GetPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
    }
    setExternalResourse(extResId) {
        this.setFieldValue(FieldsFactory.FIELD_EXT_RESOURCE, extResId);
    }
}
